import React from 'react';
import HandsScrollAnimation from '../components/common/HandsScrollAnimation';
import './Home.css';

const Home = () => {
  return (
    <div id="home" className="home">

      <HandsScrollAnimation />

      {/* Marquee Section */}
      <div className="marquee-wrapper">
        <div className="marquee-container marquee-left">
          <div className="marquee-content">
            <span className="marquee-text">DHWANI 2026 // IGNITE THE FIRE // FEEL THE PASSION // UNLEASH YOUR TALENT // </span>
            <span className="marquee-text">DHWANI 2026 // IGNITE THE FIRE // FEEL THE PASSION // UNLEASH YOUR TALENT // </span>
            <span className="marquee-text">DHWANI 2026 // IGNITE THE FIRE // FEEL THE PASSION // UNLEASH YOUR TALENT // </span>
            <span className="marquee-text">DHWANI 2026 // IGNITE THE FIRE // FEEL THE PASSION // UNLEASH YOUR TALENT // </span>
          </div>
        </div>
      </div>

    </div>
  );
};

export default Home;